export default "__VITE_ASSET__DGGXSjCn__"